import { Controller } from 'react-hook-form';
import { FC } from 'react';

import { TermostatstyringRadio } from '../components/termostatstyringRadio';
import { AboutFormControlProps } from '../../types';
import { OppvarmingBrukRadio } from '../components/oppvarmingBrukRadio';
import { ServiceRadio } from '../components/serviceRadio';
import { YearNumberField } from '../../general/components/yearNumberField';

export const Ventilasjon: FC<AboutFormControlProps> = ({ control }) => (
  <>
    <Controller
      control={control}
      name="oppvarming.oppvarmingVarmepumpe.ventilasjon.varmesentral"
      render={({ field: { value, onChange }, fieldState }) => (
        <TermostatstyringRadio
          onChange={onChange}
          error={fieldState.error}
          value={value}
          labelKey="register.varmesentral.ventilasjon.label"
          informationKey="register.varmesentral.ventilasjon.information"
        />
      )}
    />

    <Controller
      control={control}
      name="oppvarming.oppvarmingVarmepumpe.ventilasjon.bruk"
      render={({ field: { value, onChange }, fieldState }) => (
        <OppvarmingBrukRadio onChange={onChange} error={fieldState.error} value={value} />
      )}
    />

    <Controller
      control={control}
      name="oppvarming.oppvarmingVarmepumpe.ventilasjon.installasjonsAr"
      render={({ field: { value, onChange }, fieldState }) => (
        <YearNumberField
          error={fieldState.error}
          value={value}
          informationKey="register.tekniskUtstyr.ventilasjon.installasjonsAr.information"
          onChange={(value) => {
            onChange(value);
          }}
        />
      )}
    />

    <Controller
      control={control}
      name="oppvarming.oppvarmingVarmepumpe.ventilasjon.serviceGjennomfortSiste2Ar"
      render={({ field: { value, onChange }, fieldState }) => (
        <ServiceRadio
          value={value}
          i18nPrefix="register.tekniskUtstyr.ventilasjon.serviceGjennomfortSiste2Ar"
          onChange={(val) => onChange(val)}
          error={fieldState.error}
        />
      )}
    />
  </>
);
